import clsx, {ClassValue} from "clsx";
import {twMerge} from "tailwind-merge";

/**
 * Combines the clsx and tailwind-merge utilities.
 *
 * clsx enables the use of list and object syntax for class names.
 * See https://www.npmjs.com/package/clsx.
 *
 * tailwind-merge enables the merging of lists of classes without conflicts.
 * See https://www.npmjs.com/package/tailwind-merge.
 */
const clsMerge = (...inputs: ClassValue[]) => twMerge(clsx(...inputs));

export default clsMerge;
